import intl from "react-intl-universal";
import { Tag, Tooltip } from "antd";
import styles from './index.module.scss';
import { EyeOutlined, StarFilled, CarryOutOutlined } from '@ant-design/icons';
import publicImg from "@/assets/images/discover/public.png";
import unpublic from "@/assets/images/discover/unpublic.png";
import computable from "@/assets/images/discover/computable.png";
import { useMemo } from "react";
import { useSelector } from "react-redux";
let columns = [], data_zh = [], data_EN = [];
export const useColumns = (state) => {
  const { userInfo } = useSelector(state => state.user)
  const nicknName = useMemo(() => userInfo?.nickname, [userInfo])
  const password = useMemo(() => userInfo?.password, [userInfo])
  const email = useMemo(() => userInfo?.email, [userInfo])
  const linkOutUrl = (url) => {
    const newPassword = password.replace(/\+/g, "!");
    return `${url}?u=${nicknName}&p=${newPassword}&e=${email}`
  };
  switch (state) {
    case "tools":
      columns = [
        {
          title: intl.get("Tool Name"),
          key: "toolName",
          dataIndex: "toolName",
          width: 160,
        },
        {
          title: intl.get("Release Url"),
          key: "url",
          width: 160,
          render: (text, record) => (
            <a href={linkOutUrl(record.url)} rel="noreferrer" target="_blank">
              {intl.get("Url Address")}
            </a>
          ),
        },
      ];
      data_zh = [
        {
          id: "1-1",
          toolName: "Luojiaset线上标注平台",
          url: "https://ogeoa.net/luojiaSet/annotations/taskManage",
        },
        {
          id: "1-2",
          toolName: "osm2tdml",
          url: `http://ogeoa.net${process.env.PUBLIC_URL}/discover/detail?id=OpenCodes-a2fc04da-6319-49e5-afb0-6713c8545d39`,
        },
        {
          id: "1-3",
          toolName: "PyTDML",
          url: `http://ogeoa.net${process.env.PUBLIC_URL}/discover/detail?id=OpenCodes-2ff1f0c3-f62e-4f58-ade2-0d68bd514f97`,
        },
        {
          id: "1-4",
          toolName: "GeoSam辅助标注",
          url: "http://openge.org.cn:9009",
        },
      ];
      data_EN = [
        {
          id: "1-1",
          toolName: "Luojiaset Online annotation platform",
          url: "https://ogeoa.net/luojiaSet/annotations/taskManage",
        },
        {
          id: "1-2",
          toolName: "osm2tdml",
          url: `http://ogeoa.net${process.env.PUBLIC_URL}/discover/detail?id=OpenCodes-a2fc04da-6319-49e5-afb0-6713c8545d39`,
        },
        {
          id: "1-3",
          toolName: "PyTDML",
          url: `http://ogeoa.net${process.env.PUBLIC_URL}/discover/detail?id=OpenCodes-2ff1f0c3-f62e-4f58-ade2-0d68bd514f97`,
        },
        {
          id: "1-4",
          toolName: "GeoSam",
          url: "http://openge.org.cn:9009",
        },
      ];
      break;

    case "task":
      columns = [
        {
          title: intl.get("Task Number"),
          key: "taskNumber",
          width: 100,
          render: (text, record, index) => {
            return <div>{index + 1}</div>;
          },
        },
        {
          title: intl.get("Share.File Name"),
          dataIndex: "fileName",
          key: "fileName",
          width: 160,
        },
        {
          title: intl.get("Task Type"),
          dataIndex: "taskType",
          key: "taskType",
          width: 110,
        },
        {
          title: intl.get("Release Date"),
          dataIndex: "releaseDate",
          key: "releaseDate",
          width: 110,
        },
        {
          title: intl.get("Status"),
          dataIndex: "status",
          key: "status",
          width: 80,
          render: (text, record) => (
            <Tag color={text === 2 ? "green" : "geekblue"}>
              {text === 2 ? intl.get("Released") : intl.get("Completed")}
            </Tag>
          ),
        },
        {
          title: intl.get("Release Url"),
          dataIndex: "url",
          key: "url",
          width: 110,
          render: (text, record) => (
            <a href={record.url} rel="noreferrer" target="_blank">
              {intl.get("Url Address")}
            </a>
          ),
        },
      ];
      data_zh = [
        {
          id: "1-1",
          fileName: "天河机场标注",
          taskType: "目标检测",
          releaseDate: "2025-2-19",
          url: "https://ogeoa.net/luojiaSet/annotations/taskManage",
          status: 2,
        },
        {
          id: "1-2",
          fileName: "武汉一号标注",
          taskType: "语义分割",
          releaseDate: "2025-1-26",
          url: "https://ogeoa.net/luojiaSet/annotations/taskManage",
          status: 2,
        },
      ];
      data_EN = [
        {
          id: "1-1",
          fileName: "Tian'he Airport",
          taskType: "Object Detection",
          releaseDate: "2025-2-19",
          url: "https://ogeoa.net/luojiaSet/annotations/taskManage",
          status: 2,
        },
        {
          id: "1-2",
          fileName: "Wuhan No.1",
          taskType: "Semantic Segmentation",
          releaseDate: "2025-1-26",
          url: "https://ogeoa.net/luojiaSet/annotations/taskManage",
          status: 2,
        },
      ];
      break;
    case "standards":
      columns = [
        {
          title: "",
          key: "icon_bar",
          width: 100,
          render: (text, record, index) => (
            <div className={styles.iconBox}>
              {record.resourceType && (
                <Tooltip title={record.resourceType.typeName}>
                  <img src={process.env.REACT_APP_API_AFFIX + record.resourceType.imgPath} />
                </Tooltip>
              )}
              {record.secondType !== "OpenDataServices" &&
                record.secondType !== "OpenProcessServices" &&
                record.secondType !== "OpenWebApps" && (
                  <Tooltip
                    title={
                      record.isDownloadable
                        ? "Downloadable"
                        : "Not downloadable"
                    }
                  >
                    <img src={record.isDownloadable ? publicImg : unpublic} />
                  </Tooltip>
                )}
              {record.isComputable && (
                <Tooltip title={"Computable"}>
                  <img src={computable} />
                </Tooltip>
              )}
            </div>
          ),
        },
        {
          title: intl.get("Title"),
          dataIndex: "title",
          key: "title",
          width: 330,
          render: (text, record, index) => (
            <Tooltip
              placement="rightTop"
              styles={{
                root: { maxWidth: 500 }
              }}
              title={record.description}
            >
              <a
                target="_blank"
                href={`${process.env.PUBLIC_URL}/discover/detail?id=${record.resourceUuid}`}
              >
                {text}
              </a>
            </Tooltip>
          ),
        },
        {
          title: intl.get("Contributor"),
          dataIndex: "contributor",
          key: "Contributor",
          width: 100,
          render: (text, record) => (
            <div>
              {record.contributors ? record.contributors[0].username : ""}
            </div>
          ),
        },
        {
          title: intl.get("Date Created"),
          dataIndex: "createTime",
          key: "date_created",
          width: 100,
        },
        {
          title: intl.get("Last Modifiled"),
          dataIndex: "updateTime",
          key: "last_modified",
          width: 100,
        },
        {
          title: intl.get("Populartity"),
          key: "company",
          width: 150,
          render: (text, record) => (
            <div className={styles.popularBox}>
              <Tooltip title={intl.get("Views") + record.viewTimes || 0}>
                <EyeOutlined style={{ color: "#62c92f", fontSize: "18px" }} />
                <span>{record.viewTimes}</span>
              </Tooltip>

              <Tooltip
                title={intl.get("Collections") + record.collectTimes || 0}
              >
                <StarFilled style={{ color: "#d62293", fontSize: "18px" }} />
                <span>{record.collectTimes}</span>
              </Tooltip>

              <Tooltip
                title={intl.get("Downloads") + record.downloadTimes || 0}
              >
                <CarryOutOutlined
                  style={{ color: "#5AB6F9", fontSize: "18px" }}
                />
                <span>{record.downloadTimes}</span>
              </Tooltip>
            </div>
          ),
        },
      ];
      break;
    default:
      break;
  }

  return {
    columns,
    data_zh,
    data_EN,
  };
};
